import React from 'react';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { selectCanBeSubmitted } from '../../../../../selectors';

const AddToCartButton = ({ addProductToCart }) => {
  const canBeSubmitted = useSelector(selectCanBeSubmitted);
  if (!canBeSubmitted) {
    return (
      <button
        className="bnl-product-config__button button awaiting-config"
        onClick={() => {
          Swal.fire(`Please finish configuring your product`);
          return false;
        }}
      >
        Add to Cart
      </button>
    );
  }

  return (
    <button
      className="bnl-product-config__button  button"
      onClick={() => {
        addProductToCart();
      }}
    >
      Add to Cart
    </button>
  );
};

export default AddToCartButton;
